import React from 'react';
import { getLabel } from '../../../../data/labels';
import { formatDate } from '../../../utils/formatDate';
import { getConfiguration } from '../../../utils/configuration';
import { getCurrencyValue } from '../../../utils/getCurrencyValue';
import { getDBTimestampFromDate } from '../../../utils/getDBTimestampFromDate';
import { getFormattedTimestamp } from '../../../utils/getFormattedTimestamp';
import { getPrintableAmount } from '../../../utils/getPrintableAmount';


function CommonBalanceReceipt(props) {
	const conf = getConfiguration();
	const marginTop55 = {
			'marginTop':'55px'
	};
	
	const opData = props.detailedBalanceData;	
	const terminalBalance = getCurrencyValue(opData.object.tb, conf.cs.m, conf.cs.nd, conf.cs.ct);
	
	let fromTo = null;
	if(props.showFromToDate){
		const values = [getLabel('retail.from'), formatDate(opData.object.tsf, false).formatted_no_hour, getLabel('retail.to'), formatDate(opData.object.tst, false).formatted_no_hour];
		fromTo = values.join(' ');
	}
	
	function getTotals(transactions){
		let numOps = 0;
		let totalAmount = 0;
		let effectiveAmount = 0;
		for(let k in transactions){
			numOps += transactions[k].not;
			let amount = transactions[k].amn;
			totalAmount += transactions[k].amn;
			if( transactions[k].sig != 0){
				effectiveAmount += (transactions[k].sig * amount);
			}
		}
		return {
			numOps,
			totalAmount,
			effectiveAmount
		}
	}
	const startingRegisterBalance = getCurrencyValue(opData.object.tb - getTotals(opData.object.trns).effectiveAmount, conf.cs.m, conf.cs.nd, conf.cs.ct);

	function BalanceDetail(props){
		const transactions = props.transactions;
		const totals = getTotals(transactions);
		const numOps = totals.numOps;
		const totalAmount = totals.totalAmount;
		const effectiveAmount = totals.effectiveAmount;

		return <>
		{props.nickname && <div className={"reportBorderedOperatorName"}> {props.nickname} </div>}
		{props.printSummaryLabel && <div className={"reportBorderedOperatorName"}> {getLabel('retail.shop_detailed_balance.summary').toUpperCase()} </div>}
		<table className="width100x100">
			<thead>
				<th className="uppercase">{getLabel('retail.causal')}</th>
				{props.showMov && <th className="uppercase">{getLabel('retail.mov')}</th>}
				<th className="uppercase">{getLabel('retail.amount')}</th>
			</thead>
			<tbody>
			{
				Object.keys(transactions).map((key)=> {
					const transaction = transactions[key];
					return <tr key={'tr-' + key}>
						<td className='text-center'>{transaction.ds}</td>
						{props.showMov && <td className='text-center'> {transaction.not} </td>}
						<td className='text-center'> {getPrintableAmount(transaction.amn, conf.cs.m, conf.cs.nd)} </td>
					</tr>
					
				})
			}
			</tbody>
		</table>
		<div style={marginTop55}></div>
		
		{props.showTotOperations && <div className="operationMonospace"> {getLabel('retail.op_number')} : {numOps} </div>}
		{props.showEffectiveAmount && 
			<div className="operationMonospace"> {getLabel('retail.net_total')} : {getCurrencyValue(effectiveAmount, conf.cs.m, conf.cs.nd, conf.cs.ct)} </div>
		}
		{
			props.showTotalWithoutSign && <div className="operationMonospace"> {getLabel('retail.total_amount')} : {getCurrencyValue(totalAmount, conf.cs.m, conf.cs.nd, conf.cs.ct)} </div>
		}
		{
			props.terminalBalance && props.showTerminalBalance && <div className="operationMonospace">{getLabel('retail.terminal_balance') + ": " + props.terminalBalance}</div>
		}
		
		</>
	}
	
	const transactionsByOperatorKeys = opData.object.tsbo? Object.keys(opData.object.tsbo) : null;
	let timestampToShow = getFormattedTimestamp();
	if(opData.object.ts){
		const timestampNow = getDBTimestampFromDate().split(" ")[0];
		if(opData.object.ts.split(" ")[0] !== timestampNow){
			// se la data richiesta è diversa da oggi, il report si riferisce alla data richiesta
			timestampToShow = formatDate(opData.object.ts + " 23:59", true).formatted;
		}
	}
	return <>	
		<div>{getLabel('retail.date_time') + ": " + timestampToShow}</div>
		{
			props.showTerminalBalance && <>
				<div>{getLabel('retail.detailed_balance.initial_amount') + ": " + startingRegisterBalance}</div>
				{/*<div>{getLabel('retail.terminal_balance') + ": " + terminalBalance}</div> */}
			</>
		}
		{
			props.showPvend && <div>{getLabel('retail.shop_pvend') + ": " + opData.object.pvend}</div>
		}
		{
			fromTo && <div> {fromTo} </div>
		}
		<div>{getLabel('retail.terminal_number') + ": " + opData.object.tag}</div>
		<div>{getLabel('retail.operator') + ": " + opData.operator}</div>
		<hr className="hr-line-no-margin-bottom" />
		<BalanceDetail transactions={opData.object.trns} {...props} printSummaryLabel={transactionsByOperatorKeys !=  null} terminalBalance={terminalBalance} />
		
		{
			transactionsByOperatorKeys && 
			<>
			<hr className="hr-line-no-margin-bottom" />
			{
				transactionsByOperatorKeys.map((key, index)=> {
					const transactions = opData.object.tsbo[key];
					const isLast = index === transactionsByOperatorKeys.length - 1;
					return <React.Fragment key={key}> 
						<BalanceDetail transactions={transactions} {...props} nickname={key} />
						{!isLast && <hr className="hr-line-no-margin-bottom" />}
					</React.Fragment>
				})
			}

			</>
		}
	</>
}

export default CommonBalanceReceipt;